module.exports = {
        srcSet: __webpack_public_path__ + "static/media/relocation_mobile-640.ad029031.webp"+" 640w",
        images: [{path: __webpack_public_path__ + "static/media/relocation_mobile-640.ad029031.webp",width: 640,height: 427}],
        src: __webpack_public_path__ + "static/media/relocation_mobile-640.ad029031.webp",
        toString: function(){return __webpack_public_path__ + "static/media/relocation_mobile-640.ad029031.webp"},
        
        width: 640,
        height: 427
      }